module.exports = __webpack_public_path__ + "static/media/faq.9a2871ab.svg";